import {
  GET_JOURNEY_GRAPH,
  GET_JOURNEY_GRAPH_SUCCESS,
  GET_JOURNEY_GRAPH_FAILURE,
  SAVE_JOURNEY_GRAPH,
  SAVE_JOURNEY_GRAPH_SUCCESS,
  SAVE_JOURNEY_GRAPH_FAILURE,
  PUBLISH_JOURNEY_GRAPH,
  PUBLISH_JOURNEY_GRAPH_SUCCESS,
  PUBLISH_JOURNEY_GRAPH_FAILURE,
  VALIDATE_JOURNEY_GRAPH,
  VALIDATE_JOURNEY_GRAPH_SUCCESS,
  VALIDATE_JOURNEY_GRAPH_FAILURE,
} from "./constants";

export const getJourneyGraph = (payload, onSuccess) => ({
  type: GET_JOURNEY_GRAPH,
  payload,
  onSuccess,
});
export const getJourneyGraphSuccess = (payload) => ({
  type: GET_JOURNEY_GRAPH_SUCCESS,
  payload,
});
export const getJourneyGraphFailure = () => ({
  type: GET_JOURNEY_GRAPH_FAILURE,
});

export const saveJourneyGraph = (payload, onSuccess) => ({
  type: SAVE_JOURNEY_GRAPH,
  payload,
  onSuccess,
});
export const saveJourneyGraphSuccess = (payload) => ({
  type: SAVE_JOURNEY_GRAPH_SUCCESS,
  payload,
});
export const saveJourneyGraphFailure = () => ({
  type: SAVE_JOURNEY_GRAPH_FAILURE,
});

export const publishJourneyGraph = (payload, onSuccess) => ({
  type: PUBLISH_JOURNEY_GRAPH,
  payload,
  onSuccess,
});
export const publishJourneyGraphSuccess = (payload) => ({
  type: PUBLISH_JOURNEY_GRAPH_SUCCESS,
  payload,
});
export const publishJourneyGraphFailure = (payload) => ({
  type: PUBLISH_JOURNEY_GRAPH_FAILURE,
  payload,
});

export const validateJourneyGraph = (payload, onSuccess) => ({
  type: VALIDATE_JOURNEY_GRAPH,
  payload,
  onSuccess,
});
export const validateJourneyGraphSuccess = (payload) => ({
  type: VALIDATE_JOURNEY_GRAPH_SUCCESS,
  payload,
});
export const validateJourneyGraphFailure = () => ({
  type: VALIDATE_JOURNEY_GRAPH_FAILURE,
});
